import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useMode, MODES } from '../context/ModeContext';
import Navbar from '../pages/Navbar';
import Footer from '../pages/Footer';

function FiatLayout() {
    const { mode, setMode, hasSelectedMode } = useMode();
    const navigate = useNavigate();

    useEffect(() => {
        // If no mode selected, redirect to mode selector
        if (!hasSelectedMode) {
            navigate('/select-mode');
            return;
        }

        // If mode is crypto, redirect to crypto
        if (mode === MODES.CRYPTO) {
            navigate('/crypto');
            return;
        }

        // Ensure fiat mode is set
        if (mode !== MODES.FIAT) {
            setMode(MODES.FIAT);
        }
    }, [mode, hasSelectedMode, navigate, setMode]);

    return (
        <div className="app-layout fiat-layout">
            <Navbar mode="fiat" />
            <main className="main-content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

export default FiatLayout;
